import { useState, type FormEvent } from 'react';

import { user } from 'core';
import { SearchInput } from 'ui/components';

const ShippingModelSearchBarWidget = () => {
  const [focus, toggleFocus] = useState(false);
  const handleFocus = () => toggleFocus(!focus);

  const { setSearchInput, setSearchTracking } = user.commands.useUserCommand();

  const handleSearchInput = (searchInput: string) => {
    setSearchInput(searchInput);
    if (searchInput.length > 2) {
      setSearchTracking(searchInput);
    }
  };

  const handleSearchClick = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
  };

  return (
    <SearchInput
      id="search-pickup-store"
      onChangeSearch={handleSearchInput}
      onFocus={handleFocus}
      onSearchClick={handleSearchClick}
      placeholder="Busque o nome ou endereço"
      type="text"
    />
  );
};

export default ShippingModelSearchBarWidget;
